import { render } from "./B2bLoginPasswordFormRenfe.vue?vue&type=template&id=1265b722&scoped=true&lang=pug"
import script from "./B2bLoginPasswordFormRenfe.vue?vue&type=script&lang=js"
export * from "./B2bLoginPasswordFormRenfe.vue?vue&type=script&lang=js"

import "./B2bLoginPasswordFormRenfe.vue?vue&type=style&index=0&id=1265b722&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1265b722"]])

export default __exports__